import { useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import { Calendar, CalendarAttributes, Trip } from "../js/parsegenerated";

export const StopDetail = observer((props: { id: string }) => {
  const t = useTranslation();
  const [calendar, setCalendar] = useState<Calendar>();
  const days: Map<keyof CalendarAttributes, string> = new Map<
    keyof CalendarAttributes,
    string
  >([
    ["monday", "Montag"],
    ["tuesday", "Dienstag"],
    ["wednesday", "Mittwoch"],
    ["thursday", "Donnerstag"],
    ["friday", "Freitag"],
    ["saturday", "Samstag"],
    ["sunday", "Sonntag"],
  ]);

  function getDays() {
    const dayselements = [];
    for (const day of days.entries()) {
      if (calendar.get(day[0])) {
        dayselements.push(
          <span style={{ marginRight: 15 }} key={day[0]}>
            {day[1]}{" "}
            <Icon
              icon="fa:check"
              style={{ color: "var(--opendash-color-green)" }}
            />
          </span>
        );
      } else {
        dayselements.push(
          <span style={{ marginRight: 15 }} key={day[0]}>
            {day[1]}{" "}
            <Icon
              icon="fa:times"
              style={{ color: "var(--opendash-color-red)" }}
            />
          </span>
        );
      }
    }

    return dayselements;
  }

  useEffect(() => {
    new Parse.Query(Trip).get(props.id).then(async (tripobject) => {
      setCalendar(await tripobject.get("service_id").fetch());
    });
  }, []);

  return (
    <>
      <div style={{ marginBottom: 20 }}>{calendar ? getDays() : null}</div>

      <div style={{ marginBottom: 20 }}>
        {calendar ? calendar.get("start_date").toLocaleDateString() : null}{" "}
        {" - "}{" "}
        {calendar ? calendar.get("end_date").toLocaleDateString() : null}
      </div>
    </>
  );
});
